import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { Team, TeamPurchaseOrderPhase, TeamSalesOrderPhase, WorkspacePurchaseOrderPhase } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 2560. ワークスペース発注フェーズ一覧
 * [GET] /workspaces/:identifier/workspace_purchase_order_phases
 */
type Props = {
  identifier: string;
};
const workspacePurchaseOrderPhases = (props: Props): Promise<WorkspacePurchaseOrderPhase[]> => {
  return axios.get(`/api/workspaces/${props.identifier}/workspace_purchase_order_phases`, {
    params: props,
  });
};

export const useWorkspacePurchaseOrderPhases = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => workspacePurchaseOrderPhases(props),
  });
};

export const useInvalidateWorkspacePurchaseOrderPhases = (props: Props) => {
  const invalidate = async () => {
    await queryClient.invalidateQueries({
      queryKey: queryKey(props),
    });
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return ['workspaces', props.identifier, 'workspace_purchase_order_phases'];
};
